<template>
 <main class="grid gap-4">
    <div class="grid">
      <p class="label-text-medium">Select a Product</p>
      <p class="secondary-heading-text">Choose the right product for your business needs</p>
    </div>
      <ProductCard
        v-for="product in products"
        :key="product.id"
        :product="product"
        :isSelected="selectedProduct === product.id"
        :isExpanded="expandedProduct === product.id"
        @toggle="toggleProduct(product)"
      />
    <span class="grid pb-10"></span>
    <section class="footer z-10">
      <custom-button
        @click.prevent="selectNbfc()"
        arrowAnimation
        :disabled="!this.selectedProduct"
        :variant="!this.selectedProduct ? 'disableGray' : 'primary'"
      >
        <p class="grid text-base">
          Next
        </p>
      </custom-button>
    </section>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
 </main>
</template>
<script>
import { mapGetters } from 'vuex';
import { toRaw } from 'vue';
import ProductCard from '../components/ProductCard.vue';
import bnplLogo from '../assets/logo-product-bnpl.svg';
import ediLogo from '../assets/logo-product-edi.svg';
// import muthootLogo from '../assets/muthootLogo.png';
import CustomButton from '../components/CustomButton.vue';
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'Product Cards',
  components: {
    ProductCard,
    CustomButton,
    SpinLoader
  },
  computed: {
    ...mapGetters(['applicationId', 'flagsData', 'applicationSummary']),
  },
  data() {
    return {
      isSpinLoading: false,
      selectedProduct: null,
      selectedProductData: null,
      expandedProduct: null,
      products: [],
      productsDetails: [
        {
          productType: "edi",
          logo: ediLogo,
          title: "Instant Funds, Zero Hassle",
          description: "Instant money in your bank with flexible repayments for your cash flow needs.",
          subDescription1: 'Get Instant Money in Your Bank Account',
          details: {
            points: [
              "Get money directly in your bank account.",
              "Repay in small daily or weekly amounts that match your sales.",
            ],
          },
        },
        {
          productType: "bnpl",
          logo: bnplLogo,
          title: "Buy Now, Pay Later",
          description: "Get credit for business purchases with flexible repayment.",
          subDescription1: 'Use your credit only at partnered platforms like',
          details: {
            points: [
              "Buy wholesale now, pay later.",
              "0% interest for up to 14 days at selected partners.",
              "Easy repayment with low interest."
            ],
          },
          partnerImage: [
            { name: 'flipkart', img: require('@/assets/flipkart-icon.svg'), displayName: 'Flipkart wholesale' },
            { name: 'lots', img: require('@/assets/lots-icon.svg'), displayName: 'LOTS Wholesale Solutions' },
            { name: 'bigBasket', img: require('@/assets/bigBasket-icon.png'), displayName: 'Bigbasket' },
            { name: 'metro', img: require('@/assets/metro-icon.png'), displayName: 'Metro Cash and Carry' },
            { name: 'unilever', img: require('@/assets/unilever-icon.svg'), displayName: 'Hindustan Unilever' },
            { name: 'patanjali', img: require('@/assets/patanjali-icon.png'), displayName: 'Patanjali' },
            { name: 'dawaai', img: require('@/assets/dawaai-icon.png'), displayName: 'Dawaai' },
            { name: 'syngenta', img: require('@/assets/syngenta-icon.png'), displayName: 'Syngenta' },
            { name: 'adinath_argo', img: require('@/assets/adinath_argo-icon.png'), displayName: 'Adinath Argo' },
            { name: 'arraykart', img: require('@/assets/arraykart-icon.png'), displayName: 'Arraykart' },
            { name: 'apnaklub', img: require('@/assets/apnaklub-icon.png'), displayName: 'Apnaklub' },
            { name: 'alpino', img: require('@/assets/alpino-icon.png'), displayName: 'Alpino' },
            { name: 'nurture', img: require('@/assets/nurture-icon.png'), displayName: 'Nurture' },
            { name: 'maxx', img: require('@/assets/maxx-icon.png'), displayName: 'Maxx Food and Beverages' },
          ]
        },
      ],
    };
  },
  mounted() {
    this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PRODUCT_OFFERS_LANDING);
    this.getApplicationApprovals();
  },
  methods: {
    mapProducts(productsToMap) {
      return productsToMap?.map((product, index) => {
        const matchedDetail = this.productsDetails.find(
          (detail) => detail.productType?.toLowerCase() === product.productType?.toLowerCase()
        );
        return {
          ...product,
          id: index + 1,
          ...(matchedDetail ? toRaw(matchedDetail) : {})
        };
      }) || [];
    },
    handleEdiLoan(checkEdiLoanData) {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_RISK_RUN_SUCCESSFULL, {
        [this.$mixpanelPayload.KEY_MESSAGE]: 'EDI loan is present, redirecting based on further condition(Agreement/Mandate).',
      });
      if (!checkEdiLoanData?.isAgreementSigned) {
        this.$router.push({
          name: 'Loan Agreement',
          query: {
            isAgreementSigned: !checkEdiLoanData?.isAgreementSigned,
            isEdiFlow: true,
            isBankInfoPresent: checkEdiLoanData?.isBankInfoPresent,
            isMandate: checkEdiLoanData?.mandateStatus?.registrationRequired,
            loanId: checkEdiLoanData.loanId
          }
        });
      } else if (checkEdiLoanData?.isBankInfoPresent && checkEdiLoanData?.mandateStatus?.registrationRequired) {
        this.$router.push({
          name: 'Edi Bank Statement',
          query: {
            isEdiFlow: true,
            isBankInfoPresent: checkEdiLoanData?.isBankInfoPresent,
            loanId: checkEdiLoanData.loanId,
            isMandate: checkEdiLoanData?.mandateStatus?.registrationRequired,
          }
        });
      } else if (!checkEdiLoanData?.isBankInfoPresent) {
        this.$router.push({
          name: 'Edi Bank Statement',
          query: {
            isEdiFlow: true,
            loanId: checkEdiLoanData.loanId,
            isMandate: !checkEdiLoanData?.mandateStatus?.registrationRequired,
          }
        });
      } else {
        this.$router.push({
          name: 'Mandate Success',
          query: {
            isEdiFlow: true,
            mandateEdi: checkEdiLoanData?.mandateStatus?.registrationRequired,
            loanId: checkEdiLoanData.loanId
          }
        });
      }
    },
    handleBnplLoan(res, checkBnplLoanData) {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_RISK_RUN_SUCCESSFULL, {
        [this.$mixpanelPayload.KEY_MESSAGE]: 'Only show BNPL Loan in UI and EDI offer not present.',
      });
      const summaryData = this.applicationSummary;
      const hasAnyBusinessDoc = [
        summaryData?.businessInfo?.udyamDetails,
        summaryData?.businessInfo?.gstin,
        summaryData?.documentListUploaded?.fssaiUploaded,
        summaryData?.documentListUploaded?.fdaUploaded,
        summaryData?.documentListUploaded?.shopAndEstablishmentUploaded,
        summaryData?.documentListUploaded?.othersUploaded,
      ].some(Boolean);
      if (res?.ediriskRunDone && hasAnyBusinessDoc) {
        if (!this.flagsData?.digilockerVerified) {
          this.$router.push({ name: 'Pre Approval KYC Selection',
            query: {
              isMandate: this.selectedProductData?.mandateStatus?.registrationRequired,
              loanId: checkBnplLoanData.loanId,
              isBnplFlow: true,
              isAgreementSigned: !checkBnplLoanData.isAgreementSigned,
            }
          });
        } else if (!checkBnplLoanData.isAgreementSigned) {
          this.$router.push({
            name: 'Loan Agreement',
            query: {
              isMandate: this.selectedProductData?.mandateStatus?.registrationRequired,
              loanId: checkBnplLoanData.loanId,
              isBnplFlow: true,
              isAgreementSigned: !checkBnplLoanData.isAgreementSigned,
            }
          });
        } else if (checkBnplLoanData?.mandateStatus?.registrationRequired) {
          this.$router.push({
            name: 'Post Approval Step 1',
            query: {
              isMandate: this.selectedProductData?.mandateStatus?.registrationRequired,
              loanId: checkBnplLoanData.loanId,
            }
          });
        } else {
          this.$router.push({
            name: 'Mandate Success',
            query: {
              loanId: checkBnplLoanData.loanId,
              isBnplFlow: true
            }
          });
        }
      } else {
        this.$router.push({ name: 'Pre Approval Step 3' });
      }
    },
    async getApplicationApprovals() {
      this.isSpinLoading = true;
      this.$store
        .dispatch('applicationApprovals', {
          applicationId: this.applicationId,
          urlParams: {
            option: 'best',
          },
        })
        .then((res) => {
          const response = res?.result?.filter(p => p.status?.toLowerCase() !== "rejected");
          const validProducts = response?.filter(p => p.amountApproved > 0) || [];

          // Consolidated rejection check - reject if no valid products with amountApproved > 0
          if (!response?.length || !validProducts?.length) {
            this.$router.push({ name: "Application Rejected" });
            this.isSpinLoading = false;
            return;
          }

          const checkEdiLoanData = response?.find((detail) => detail.productType?.toLowerCase() === 'edi');
          const checkBnplLoanData = response?.find((detail) => detail.productType?.toLowerCase() === 'bnpl');

          if (checkEdiLoanData?.loanId) {
            this.handleEdiLoan(checkEdiLoanData);
          } else if (checkBnplLoanData?.loanId && checkEdiLoanData && !checkEdiLoanData?.loanId) {
            // only show edi offer in product page
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_RISK_RUN_SUCCESSFULL, {
              [this.$mixpanelPayload.KEY_MESSAGE]: 'BNPL loan is present and EDI offer is present, hence showing only EDI offer.',
            });
            this.products = this.mapProducts(response?.filter(p => p.productType?.toLowerCase() === 'edi'));
          } else if (checkBnplLoanData?.loanId && !checkEdiLoanData) {
            this.handleBnplLoan(res, checkBnplLoanData);
          } else if (checkBnplLoanData && !checkBnplLoanData?.loanId && !checkEdiLoanData) {
            // only show bnpl Offer in product page
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_RISK_RUN_SUCCESSFULL, {
              [this.$mixpanelPayload.KEY_MESSAGE]: 'Only show bnpl Offer in product page',
            });
            this.products = this.mapProducts(response?.filter(p => p.productType?.toLowerCase() === 'bnpl'));
          } else {
            // showing both offer only
            const productsData = this.mapProducts(response?.filter(p => p.amountApproved > 0));
            this.products = productsData;
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_RISK_RUN_SUCCESSFULL, {
              [this.$mixpanelPayload.RESPONSE]: productsData,
              [this.$mixpanelPayload.KEY_MESSAGE]: 'Both offers EDI and BNPL Show in UI.',
            });
          }
          this.isSpinLoading = false;
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    toggleProduct(data) {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_OFFER_CLICKED, {
        [this.$mixpanelPayload.KEY_MESSAGE]: data.productType,
      });
      // Toggle selection
      if (this.selectedProduct === data.id) {
        this.selectedProduct = null;
        this.selectedProductData = null;
      } else {
        this.selectedProduct = data.id;
        this.selectedProductData = data;
      }
      // Toggle expansion logic
      this.expandedProduct = this.expandedProduct === data.id ? null : data.id;
    },
    selectNbfc() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PRODUCT_NEXT_BUTTON_CLICKED);
      this.isSpinLoading = true;
      const params = {
        applicationId: this.applicationId,
        patchParams: {
          nbfc: this.selectedProductData?.nbfc,
          type: "freshLoan",
          productType: this.selectedProductData?.productType?.toLowerCase() === 'bnpl' ? '' : 'edi',
        },
      };
      this.$store
        .dispatch('applicationSelectNbfc', params)
        .then((response) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SELECT_NBFC_API, {
            [this.$mixpanelPayload.RESPONSE]: 'success',
          });
          this.isSpinLoading = false;
          if (this.selectedProductData?.productType?.toLowerCase() === 'edi') {
            this.$router.push({
              name: 'Loan Agreement',
                query: {
                  isAgreementSigned: !this.selectedProductData?.isAgreementSigned,
                  isEdiFlow: true,
                  isBankInfoPresent: this.selectedProductData?.isBankInfoPresent,
                  isMandate: this.selectedProductData?.mandateStatus?.registrationRequired || true,
                  loanId: response?.loanId,
                }
            });
          } else if (!this.flagsData?.digilockerVerified) {
            this.$router.push({ name: 'Pre Approval KYC Selection',
              query: {
                loanId: response?.loanId,
                isAgreementSigned: !this.selectedProductData?.isAgreementSigned,
                isMandate: this.selectedProductData?.mandateStatus?.registrationRequired,
                isBnplFlow: true
              }
            });
          } else {
            this.$router.push({ name: 'Loan Agreement',
              query: {
                loanId: response?.loanId,
                isAgreementSigned: !this.selectedProductData?.isAgreementSigned,
                isMandate: this.selectedProductData?.mandateStatus?.registrationRequired,
                isBnplFlow: true
              }
            });
          }
        })
        .catch((err) => {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SELECT_NBFC_API, {
            [this.$mixpanelPayload.ERROR_REASON]: err.message,
          });
          this.isSpinLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
